import firebase from "../firebase";
import { toast } from "react-toastify";
import {
  ACTION_REQUEST,
  ACTION_REQUEST_END,
  ADD_TIMLINE,
  ADD_TIMLINE_FAIL,
  CREATE_MEMOIR,
  CREATE_MEMOIR_FAIL,
  GET_MEMOIRS,
  UPDATE_MEMOIR_STATUS,
  UPDATE_MEMOIR_STATUS_FAIL,
} from "./types";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { customAlert } from "./alertActions";

export const setMediaLoading = (val) => async (dispatch) => {
  dispatch({ type: "SET_MEMOIR_MEDIA_LOADING", payload: val });
};

export const getMemoirs = (uid) => {
  return (dispatch) => {
    firebase
      .firestore()
      .collection("memoirs")
      .orderBy("start_date", "asc")
      .onSnapshot((query) => {
        var tempMemoirs = [];
        query.forEach((doc) => {
          var tempFiles = [];
          let collaboratorCheck = doc
            .data()
            .collaborators.find((collab) => collab.id == uid);
          if (doc.data().user_id == uid || collaboratorCheck) {
            firebase
              .firestore()
              .collection("memoirs")

              .doc(doc.id)

              .collection("media_files")
              .orderBy("created_at", "desc")
              .get()
              .then((mFiles) => {
                mFiles.forEach((file) => {
                  tempFiles.push({
                    id: file.id,
                    ...file.data(),
                  });
                });
              });
            tempMemoirs.push({
              id: doc.id,
              ...doc.data(),
              tempFiles,
            });
          }
        });
        dispatch({
          type: GET_MEMOIRS,
          memoirs: tempMemoirs,
        });
      });
  };
};

export const getAllMemoirs = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("memoirs")
    .onSnapshot((query) => {
      var tempMemoirs = [];
      query.forEach((doc) => {
        tempMemoirs.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_ALL_MEMOIRS",
        payload: tempMemoirs,
      });
    });
};
export const getPublicMemoirs = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("memoirs")
    .where("isMemoirPublic", "==", true)
    .onSnapshot((query) => {
      var tempMemoirs = [];
      query.forEach((doc) => {
        tempMemoirs.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_PUBLIC_MEMOIRS",
        payload: tempMemoirs,
      });
    });
};

export const createMemoir = (memoir, uid, onSuccess = (keyId) => {}) => {
  return async (dispatch) => {
    dispatch({ type: ACTION_REQUEST });
    var cover_url = "";
    var display_url = "";
    let keyId = uuidv4();
    try {
      var data = await firebase
        .storage()
        .ref()
        .child(
          memoir.cover_image.type.split("/").pop() === "jpeg"
            ? "memoir_cover_images/" + uuidv4() + ".jpg"
            : "memoir_cover_images/" +
                uuidv4() +
                "." +
                memoir.cover_image.type.split("/").pop()
        )
        .put(memoir.cover_image, {
          contentType: memoir.cover_image.type,
        });
      cover_url = await data.ref.getDownloadURL();
      var data = await firebase
        .storage()
        .ref()
        .child(
          memoir.display_image.type.split("/").pop() === "jpeg"
            ? "memoir_display_images/" + uuidv4() + ".jpg"
            : "memoir_display_images/" +
                uuidv4() +
                "." +
                memoir.display_image.type.split("/").pop()
        )
        .put(memoir.display_image, {
          contentType: memoir.display_image.type,
        });
      display_url = await data.ref.getDownloadURL();
    } catch (err) {
      console.log(err.message);
    }

    firebase
      .firestore()
      .collection("memoirs")
      .doc(keyId)
      .set({
        user_id: uid,
        ...memoir,
        collaborators: [],
        timeline: [],
        created_at: firebase.firestore.Timestamp.now(),
        cover_image: cover_url,
        display_image: display_url,
      })
      .then((res) => {
        onSuccess(keyId);
        dispatch({
          type: CREATE_MEMOIR,
        });
        dispatch({ type: ACTION_REQUEST_END });
        dispatch(customAlert(true, "Memoir Created Successfully"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);

        // toast.success('Memoir Created Successfully');
      })
      .catch((err) => {
        dispatch({
          type: CREATE_MEMOIR_FAIL,
        });
        dispatch({ type: ACTION_REQUEST_END });
      });
  };
};
export const updateMemoir = (memoir, id) => {
  return async (dispatch) => {
    dispatch({ type: ACTION_REQUEST });
    firebase
      .firestore()
      .collection("memoirs")
      .doc(id)
      .update({
        ...memoir,
      })
      .then((res) => {
        // dispatch({
        // 	type: CREATE_MEMOIR,
        // });
        dispatch({ type: ACTION_REQUEST_END });
        dispatch(customAlert(true, "Memoir updated Successfully"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // toast.success('Memoir Created Successfully');
      })
      .catch((err) => {
        dispatch({
          type: CREATE_MEMOIR_FAIL,
        });
        dispatch({ type: ACTION_REQUEST_END });
      });
  };
};
export const updateMemoirMedia = (obj, id) => {
  console.log("obj :", obj, "id :", id);
  return async (dispatch) => {
    dispatch(setMediaLoading(true));

    try {
      obj.forEach(async (item) => {
        var cover_url = "";
        var display_url = "";
        let media_data = {};
        let imagesUrl = [];
        let images = null;
        if (item.media.length > 0) {
          images = item.media;
          for (var i = 0; i < images.length; i++) {
            let filename = images[i].name;
            let ext2 = filename.slice(filename.lastIndexOf("."));
            let file_name = uuidv4() + ext2.toLowerCase();
            let storageRef = await firebase
              .storage()
              .ref("memoir_media_images/" + file_name)
              .put(images[i]);
            let url = await storageRef.ref.getDownloadURL();

            imagesUrl.push({ url, type: images[i].type });
          }

          media_data = {
            media_files: imagesUrl,
          };

          firebase
            .firestore()
            .collection("memoirs")
            .doc(id)
            .collection("media_files")
            .add({
              media_heading: item.title,
              media_files: media_data.media_files,
              media_desc: item.description,
              media_date: item.date,
            })
            .then((res) => {
              dispatch(getSingleMedia(id));
              dispatch(customAlert(true, "Memoir Media Saved"));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // toast.success('Memoir Media Saved');
              dispatch(setMediaLoading(false));
            })
            .catch((err) => {
              // toast.error(err.message);
              dispatch(customAlert(true, err.message));
              console.log(err.message);
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              dispatch(setMediaLoading(false));
            });
        } else {
          media_data = {
            media_files: null,
          };
          firebase
            .firestore()
            .collection("memoirs")
            .doc(id)
            .collection("media_files")
            .add({
              media_heading: item.title,
              media_files: media_data.media_files,
              media_desc: item.description,
              media_date: item.date,
            })
            .then((res) => {
              dispatch(getSingleMedia(id));
              dispatch(customAlert(true, "Memoir Media Saved"));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // toast.success('Memoir Media Saved');
              dispatch(setMediaLoading(false));
            })
            .catch((err) => {
              // toast.error(err.message);
              dispatch(customAlert(true, err.message));
              console.log(err.message);
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              dispatch(setMediaLoading(false));
            });
        }
      });
    } catch (err) {
      // toast.error(err.message);
      dispatch(customAlert(true, err.message));
      console.log(err.message);
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      dispatch(setMediaLoading(false));
    }
  };
};

export const createTimeline = (memoir_id, timeline) => {
  return async (dispatch) => {
    dispatch({ type: ACTION_REQUEST });
    var tempUrl = "";
    var url = [];
    for (let i = 0; i < timeline.images.length; i++) {
      var data = await firebase
        .storage()
        .ref()
        .child(
          timeline.images[i].type.split("/").pop() === "jpeg"
            ? "memoir_images/" + uuidv4() + ".jpg"
            : "memoir_images/" +
                uuidv4() +
                "." +
                timeline.images[i].type.split("/").pop()
        )
        .put(timeline.images[i], {
          contentType: timeline.images[i].type,
        });
      tempUrl = await data.ref.getDownloadURL();
      url.push(tempUrl);
    }
    firebase
      .firestore()
      .collection("memoirs")
      .doc(memoir_id)
      .update({
        timeline: firebase.firestore.FieldValue.arrayUnion({
          text: timeline.text,
          url,
          date: moment().format(),
        }),
      })
      .then((res) => {
        dispatch({
          type: ADD_TIMLINE,
        });
        dispatch({ type: ACTION_REQUEST_END });
      })
      .catch((err) => {
        dispatch({
          type: ADD_TIMLINE_FAIL,
        });
        dispatch({ type: ACTION_REQUEST_END });
      });
  };
};

export const changeMemoirStatus = (memoir_id) => {
  return async (dispatch) => {
    var memoir = await firebase
      .firestore()
      .collection("memoirs")
      .doc(memoir_id)
      .get();
    var pub = !memoir.data().public;
    firebase
      .firestore()
      .collection("memoirs")
      .doc(memoir_id)
      .update({
        public: pub,
      })
      .then((res) => {
        dispatch({
          type: UPDATE_MEMOIR_STATUS,
        });
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_MEMOIR_STATUS_FAIL,
        });
      });
  };
};

//Update Memoir Display Image

export const displayImageUpdate =
  (obj, id, u_id, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch({ type: "MEMOIR_ACTION_START" });
    var memoir = await firebase.firestore().collection("memoirs").doc(id).get();
    var memoirData = memoir.data();
    var displayImage = memoirData.display_image;
    if (displayImage) {
      await firebase.storage().refFromURL(displayImage).delete();
      if (obj.display_image) {
        // let filename = obj.display_image.name;
        var storageRef = await firebase
          .storage()
          .ref()
          .child(
            obj?.display_image?.file?.type?.split("/").pop() === "jpeg"
              ? "memoir_display_images/" + uuidv4() + ".jpg"
              : "memoir_display_images/" +
                  uuidv4() +
                  "." +
                  obj?.display_image?.file?.type?.split("/").pop()
          )
          .put(obj?.display_image?.file, {
            contentType: obj?.display_image?.file?.type,
          });
        let url = await storageRef.ref.getDownloadURL();
        if (url) {
          memoirData.display_image = url;
          firebase
            .firestore()
            .collection("memoirs")
            .doc(id)
            .update(memoirData)
            .then((res) => {
              firebase
                .firestore()
                .collection("history")
                .add({
                  updated_by: u_id,
                  updated: "display image",
                  updated_at: firebase.firestore.Timestamp.now(),
                  memoir_id: id,
                })
                .then((res) => {
                  // dispatch(getSingleMemoir(id));
                  // toast.success('Updated Display image');
                  onSuccess();
                  dispatch(customAlert(true, "Updated Display image"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  dispatch({ type: "MEMOIR_ACTION_END" });
                })
                .catch((err) => {
                  dispatch(customAlert(true, err.message));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  // alert(err.message);
                  dispatch({ type: "MEMOIR_ACTION_END" });
                });
            })
            .catch((err) => {
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert(err.message);
              dispatch({ type: "MEMOIR_ACTION_END" });
            });
        } else {
          dispatch({ type: "MEMOIR_ACTION_END" });
        }
      } else {
        dispatch({ type: "MEMOIR_ACTION_END" });
      }
    } else {
      if (obj.display_image) {
        var storageRef = await firebase
          .storage()
          .ref()
          .child(
            obj?.display_image?.file?.type?.split("/").pop() === "jpeg"
              ? "memoir_display_images/" + uuidv4() + ".jpg"
              : "memoir_display_images/" +
                  uuidv4() +
                  "." +
                  obj?.display_image?.file?.type?.split("/").pop()
          )
          .put(obj?.display_image?.file, {
            contentType: obj?.display_image?.file?.type,
          });
        let url = await storageRef.ref.getDownloadURL();
        if (url) {
          memoirData.display_image = url;
          firebase
            .firestore()
            .collection("memoirs")
            .doc(id)
            .update(memoirData)
            .then((res) => {
              firebase
                .firestore()
                .collection("history")
                .add({
                  updated_by: u_id,
                  updated: "display image",
                  updated_at: firebase.firestore.Timestamp.now(),
                  memoir_id: id,
                })
                .then((res) => {
                  // dispatch(getSingleMemoir(id));
                  // toast.success('Updated Display image');
                  onSuccess();
                  dispatch(customAlert(true, "Updated Display image"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  dispatch({ type: "MEMOIR_ACTION_END" });
                })
                .catch((err) => {
                  dispatch(customAlert(true, err.message));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  // alert(err.message);
                  dispatch({ type: "MEMOIR_ACTION_END" });
                });
            })
            .catch((err) => {
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert(err.message);
              dispatch({ type: "MEMOIR_ACTION_END" });
            });
        } else {
          dispatch({ type: "MEMOIR_ACTION_END" });
        }
      } else {
        dispatch({ type: "MEMOIR_ACTION_END" });
      }
    }
  };

//Update Memoir Cover Image
export const coverImageUpdate =
  (obj, id, u_id, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch({ type: "MEMOIR_COVER_ACTION_START" });
    var memoir = await firebase.firestore().collection("memoirs").doc(id).get();
    var memoirData = memoir.data();
    var coverImage = memoirData.cover_image;
    if (coverImage) {
      await firebase.storage().refFromURL(coverImage).delete();
      if (obj.cover_image) {
        var storageRef = await firebase
          .storage()
          .ref()
          .child(
            obj?.cover_image?.file?.type?.split("/").pop() === "jpeg"
              ? "memoir_cover_images/" + uuidv4() + ".jpg"
              : "memoir_cover_images/" +
                  uuidv4() +
                  "." +
                  obj?.cover_image?.file?.type?.split("/").pop()
          )
          .put(obj?.cover_image?.file, {
            contentType: obj?.cover_image?.file?.type,
          });
        let url = await storageRef.ref.getDownloadURL();
        if (url) {
          memoirData.cover_image = url;
          firebase
            .firestore()
            .collection("memoirs")
            .doc(id)
            .update(memoirData)
            .then((res) => {
              firebase
                .firestore()
                .collection("history")
                .add({
                  updated_by: u_id,
                  updated: "cover image",
                  updated_at: firebase.firestore.Timestamp.now(),
                  memoir_id: id,
                })
                .then((res) => {
                  // dispatch(getSingleMemoir(id));
                  // toast.success('Updated Cover Image');
                  onSuccess();
                  dispatch(customAlert(true, "Updated Cover Image"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  dispatch({
                    type: "MEMOIR_COVER_ACTION_END",
                  });
                })
                .catch((err) => {
                  dispatch(customAlert(true, err.message));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  // alert(err.message);
                  dispatch({ type: "MEMOIR_ACTION_END" });
                });
            })
            .catch((err) => {
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert(err.message);
              dispatch({ type: "MEMOIR_COVER_ACTION_END" });
            });
        } else {
          dispatch({ type: "MEMOIR_COVER_ACTION_END" });
        }
      } else {
        dispatch({ type: "MEMOIR_COVER_ACTION_END" });
      }
    } else {
      if (obj.cover_image) {
        var storageRef = await firebase
          .storage()
          .ref()
          .child(
            obj?.cover_image?.file?.type?.split("/").pop() === "jpeg"
              ? "memoir_cover_images/" + uuidv4() + ".jpg"
              : "memoir_cover_images/" +
                  uuidv4() +
                  "." +
                  obj?.cover_image?.file?.type?.split("/").pop()
          )
          .put(obj?.cover_image?.file, {
            contentType: obj?.cover_image?.file?.type,
          });
        let url = await storageRef.ref.getDownloadURL();
        if (url) {
          memoirData.cover_image = url;
          firebase
            .firestore()
            .collection("memoirs")
            .doc(id)
            .update(memoirData)
            .then((res) => {
              firebase
                .firestore()
                .collection("history")
                .add({
                  updated_by: u_id,
                  updated: "cover image",
                  updated_at: firebase.firestore.Timestamp.now(),
                  memoir_id: id,
                })
                .then((res) => {
                  // dispatch(getSingleMemoir(id));
                  // toast.success('Updated Cover Image');
                  onSuccess();
                  dispatch(customAlert(true, "Updated Cover Image"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  dispatch({
                    type: "MEMOIR_COVER_ACTION_END",
                  });
                })
                .catch((err) => {
                  dispatch(customAlert(true, err.message));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  // alert(err.message);
                  dispatch({ type: "MEMOIR_ACTION_END" });
                });
            })
            .catch((err) => {
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert(err.message);
              dispatch({ type: "MEMOIR_COVER_ACTION_END" });
            });
        } else {
          dispatch({ type: "MEMOIR_COVER_ACTION_END" });
        }
      }
    }
  };

//Delete Memoir
export const deleteMemoir = (id) => async (dispatch) => {
  dispatch({ type: "MEMOIR_ACTION_START" });
  var memoir = await firebase.firestore().collection("memoirs").doc(id).get();
  var memoirData = memoir.data();
  if (memoirData) {
    if (memoirData.cover_image) {
      await firebase.storage().refFromURL(memoirData.cover_image).delete();
    }
    if (memoirData.display_image) {
      await firebase.storage().refFromURL(memoirData.cover_image).delete();
    }
    await firebase
      .firestore()
      .collection("memoirs")
      .doc(id)
      .collection("media_files")
      .get()
      .then(async (mfiles) => {
        mfiles.docs.forEach(async (file) => {
          console.log("fiel", file.data());
          // mediaFiles.push({ ...file.data() });
          if (file.data().media_files.length > 0) {
            file.data().media_files.map(async (mFile) => {
              await firebase.storage().refFromURL(mFile).delete();
            });
            await firebase
              .firestore()
              .collection("memoirs")
              .doc(id)
              .collection("media_files")
              .doc(file.id)
              .delete();
          }
        });

        await firebase.firestore().collection("memoirs").doc(id).delete();
        dispatch({ type: "MEMOIR_ACTION_END" });
      })
      .catch((err) => {
        console.log(err.message);
        dispatch({ type: "MEMOIR_ACTION_END" });
      });
  } else {
    dispatch({ type: "MEMOIR_ACTION_END" });
  }
};

export const deleteMemoirMedia = (id, media_id) => async (dispatch) => {
  dispatch(setMediaLoading(true));

  var mfiles = await firebase
    .firestore()
    .collection("memoirs")
    .doc(id)
    .collection("media_files")
    .doc(media_id)
    .get();
  if (mfiles.data().media_files?.length > 0) {
    mfiles.data().media_files?.map(async (mFile) => {
      await firebase.storage().refFromURL(mFile.url).delete();
    });
    await firebase
      .firestore()
      .collection("memoirs")
      .doc(id)
      .collection("media_files")
      .doc(media_id)
      .delete()
      .then((res) => {
        // toast.success('Media deleted successfully!');
        dispatch(customAlert(true, "Media deleted successfully!"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        dispatch(setMediaLoading(false));
      })
      .catch((err) => {
        // toast.error(err.message);
        dispatch(customAlert(true, err.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        dispatch(setMediaLoading(false));
      });
  } else {
    await firebase
      .firestore()
      .collection("memoirs")
      .doc(id)
      .collection("media_files")
      .doc(media_id)
      .delete()
      .then((res) => {
        // toast.success('Media deleted successfully!');
        dispatch(customAlert(true, "Media deleted successfully!"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        dispatch(setMediaLoading(false));
      })
      .catch((err) => {
        // toast.error(err.message);
        dispatch(customAlert(true, err.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        dispatch(setMediaLoading(false));
      });
  }
};

//Get Single Memoir

export const getSingleMemoir = (id) => async (dispatch) => {
  await firebase
    .firestore()
    .collection("memoirs")
    .doc(id)
    .onSnapshot(async (query) => {
      dispatch({
        type: "GET_SINGLE_MEMOIR",
        memoir: { id: query.id, ...query.data() },
      });
    });
};

//Get Single Memoir Media

export const getSingleMedia = (id) => async (dispatch) => {
  await firebase
    .firestore()
    .collection("memoirs")
    .doc(id)
    .collection("media_files")
    .orderBy("media_date", "desc")
    .onSnapshot(async (query) => {
      let mediaFiles = [];
      for (let doc of query.docs) {
        mediaFiles.push({ id: doc.id, ...doc.data() });
      }
      dispatch({ type: "GET_SINGLE_MEDIA", media: mediaFiles });
    });
};

// Delete Single Media file

export const deleteSingleMediaFile =
  (memoirId, mediaId, media) => async (dispatch) => {
    await firebase.storage().refFromURL(media.url).delete();
    await firebase
      .firestore()
      .collection("memoirs")
      .doc(memoirId)
      .collection("media_files")
      .doc(mediaId)
      .update({
        media_files: firebase.firestore.FieldValue.arrayRemove(media),
      });
  };

export const editMemoirMedia =
  (memoirId, mediaId, obj, media, u_id) => async (dispatch) => {
    console.log(obj, "obj");
    console.log(media, "media");
    dispatch(setMediaLoading(true));
    let imagesUrl = [];
    if (media.length >= 0) {
      for (var i = 0; i < media.length; i++) {
        let filename = media[i].name;
        let ext2 = filename.slice(filename.lastIndexOf("."));
        let file_name = uuidv4() + ext2.toLowerCase();
        let storageRef = await firebase
          .storage()
          .ref("memoir_media_images/" + file_name)
          .put(media[i]);
        let url = await storageRef.ref.getDownloadURL();
        imagesUrl.push({ url, type: media[i].type });
      }
    }
    await firebase
      .firestore()
      .collection("memoirs")
      .doc(memoirId)
      .collection("media_files")
      .doc(mediaId)
      .update(obj)
      .then((res) => {
        if (imagesUrl.length > 0) {
          imagesUrl.map((mediaImg) => {
            return firebase
              .firestore()
              .collection("memoirs")
              .doc(memoirId)
              .collection("media_files")
              .doc(mediaId)
              .update({
                media_files: firebase.firestore.FieldValue.arrayUnion(mediaImg),
              })
              .then((res) => {
                // toast.success('Media Updated Successfully!');
                dispatch(customAlert(true, "Media Updated Successfully!"));
                setTimeout(() => {
                  dispatch(customAlert(false, ""));
                }, 3000);
                dispatch(setMediaLoading(false));
              })
              .catch((err) => {
                // toast.error(err.message);
                dispatch(customAlert(true, err.message));
                setTimeout(() => {
                  dispatch(customAlert(false, ""));
                }, 3000);
                dispatch(setMediaLoading(false));
              });
          });
        } else {
          firebase
            .firestore()
            .collection("history")
            .add({
              updated_by: u_id,
              updated: "media",
              updated_at: firebase.firestore.Timestamp.now(),
              memoir_id: memoirId,
              media_id: mediaId,
            })
            .then((res) => {
              // toast.success('Media Updated Successfully!');
              dispatch(customAlert(true, "Media Updated Successfully!"));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              dispatch(setMediaLoading(false));
            })
            .catch((err) => {
              // toast.error(err.message);
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              dispatch(setMediaLoading(false));
            });
        }
      })
      .catch((err) => {
        // toast.error(err.message);
        dispatch(customAlert(true, err.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        dispatch(setMediaLoading(false));
      });
  };

export const changeMemoirViewStatus = (m_id, val) => async (dispatch) => {
  console.log("m_id", m_id, val);
  await firebase
    .firestore()
    .collection("memoirs")
    .doc(m_id)
    .update({ isMemoirPublic: val });
};
